import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const browseIssueEmbedRoute: InvariantJiraRoute = {
	name: 'issue-embed',
	path: '/browse/:issueKey(\\w+-\\d+)/embed',
};
